exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-title[data-v-b2d6855a]{border-bottom:3px solid #eeeff2;padding-bottom:20px}.about-content[data-v-b2d6855a]{border:1px groove #eeeff2;background-color:#eeeff2}.color-red[data-v-b2d6855a]{color:#dd2a1b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b2d6855a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/About.vue
// module id = 335
// module chunks = 0